import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { Reveal, Overline, Rule, Watermark } from "@/components/site/Primitives";
import { ConsultCTA } from "@/components/site/ConsultCTA";
import { Target, Wallet, ClipboardList, Users } from "lucide-react";

const ICONS = [Target, Wallet, ClipboardList, Users];

export default function FinancialPlanning() {
  const [fp, setFp] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setFp(r.data.financial_planning)).catch(() => {});
  }, []);

  if (!fp) return <div className="py-40 text-center font-sans text-steel-500">Loading…</div>;

  return (
    <>
      <Seo title="Personal Financial Planning" description="Personal financial planning from a CERTIFIED FINANCIAL PLANNER professional — general planning that connects individual goals with a clear, practical plan." />

      <section className="relative overflow-hidden border-b border-gold-500/20 bg-ink text-cream-100">
        <Watermark className="-right-4 top-6 text-[13rem] text-cream-100">CFP</Watermark>
        <div className="relative mx-auto max-w-4xl px-5 py-24 text-center lg:px-10">
          <Overline className="text-gold-400">For individuals</Overline>
          <h1 className="mt-5 font-serif text-5xl font-light leading-tight lg:text-6xl">{fp.heading}</h1>
          <Rule className="mx-auto my-7" />
          <p className="mx-auto max-w-2xl font-sans text-lg font-light leading-relaxed text-cream-100/80">{fp.intro}</p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-5 py-16 lg:px-10">
        <p className="font-serif text-2xl font-light leading-relaxed text-steel-700">{fp.body}</p>
      </section>

      <section className="mx-auto max-w-6xl px-5 pb-16 lg:px-10">
        <div className="grid gap-8 sm:grid-cols-2">
          {fp.items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.05} className="border border-ink/10 bg-cream-100 p-8">
                <Icon className="h-8 w-8 text-gold-500" strokeWidth={1.25} />
                <h2 className="mt-5 font-serif text-2xl font-light text-ink">{it.title}</h2>
                <p className="mt-3 font-sans leading-relaxed text-steel-600">{it.body}</p>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-5 pb-20 lg:px-10">
        <div className="border-l-2 border-gold-500/50 bg-cream-200/50 px-6 py-6">
          <p className="font-sans text-sm leading-relaxed text-steel-500">{fp.disclaimer}</p>
        </div>
      </section>

      <ConsultCTA heading="Plan with clarity" body="Request a consultation to discuss your personal financial planning priorities in confidence." />
    </>
  );
}
